window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Models ??= {};

AppointmentBooking.Wizard.Models.Base = class Base extends Backbone.RelationalModel {
  // Syntactic sugar
  static initializeRelations() {
    this.setup();
  }

  constructor() {
    super(...arguments);
    this.slice = this.slice.bind(this);
    this.setWithPrefix = this.setWithPrefix.bind(this);
    this.set = this.set.bind(this);
    this.attributesChanged = this.attributesChanged.bind(this);
    this.changedAttributes = this.changedAttributes.bind(this);
  }

  slice(...attrs) {
    const json = {};
    attrs.forEach((key) => (json[key] = this.get(key)));
    return json;
  }

  setWithPrefix(attributes, prefix, param = {}, ...args) {
    let { except } = param;
    if (prefix == null) {
      return this.set(attributes, ...Array.from(args));
    }

    const newAttributes = {};
    if (!_.isArray(except)) {
      except = _.compact([except]);
    }

    for (var attribute of Object.keys(attributes || {})) {
      if (_.contains(except, attribute)) {
        newAttributes[attribute] = attributes[attribute];
      } else {
        newAttributes[`${prefix}${attribute}`] = attributes[attribute];
      }
    }

    return this.set(newAttributes);
  }

  // BACKBONE OVERRIDES

  // Trigger setting and setting:attribute events
  // This lets us hook into the setters
  // Note that this will not trigger recursively if you adjust the attrsToSet in a handler
  set(key, val, options) {
    // SOURCE: https://backbonejs.org/docs/backbone.html#section-115
    let attrs;
    if (key === null) {
      return this;
    }

    if (typeof key === "object") {
      attrs = key;
      options = val;
    } else {
      (attrs = {})[key] = val;
    }

    options || (options = {});

    // Trigger the new events
    this.trigger("setting", attrs);
    jQuery.each(attrs, (key, value) => this.trigger(`setting:${key}`, key, value, attrs));

    return super.set(attrs, options);
  }

  // Returns true if any of the given attributes was changed
  attributesChanged(...attributes) {
    return !_.isEmpty(this.changedAttributes(attributes));
  }

  // Allow an array of attribute names to slice the returned attributes
  changedAttributes(attributes) {
    if (_.isArray(attributes)) {
      return _.pick(super.changedAttributes(), attributes);
    } else {
      return super.changedAttributes(attributes);
    }
  }
};
